<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { Icon } from '~ds/components/ui/icon'
import { ICONS } from '~ds/lib/icons'
import { cn } from '~ds/lib/utils'

import type { SpinnerVariants } from '.'

import { spinnerVariants } from '.'

const props = defineProps<{
  size?: SpinnerVariants['size'];
  class?: HTMLAttributes['class'];
}>()
</script>

<template>
  <div
    v-if="$slots.default"
    data-slot="spinner"
    role="status"
    aria-label="Loading"
    :class="cn(spinnerVariants({ size }), 'inline-flex [animation-duration:2s] [&>*]:size-full', props.class)"
  >
    <slot />
  </div>
  <Icon
    v-else
    :name="ICONS.loading"
    data-slot="spinner"
    role="status"
    aria-label="Loading"
    aria-hidden="false"
    :class="cn(spinnerVariants({ size }), props.class)"
  />
</template>
